import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class DistributionAPI {
  
  static list = (success, failure) => {
    fetch(Config.app.link + 'api/lead-distribution', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/lead-distribution/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (dist, success, failure) => {
    fetch(Config.app.link + 'api/lead-distribution', new Header('POST', dist))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/lead-distribution/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default DistributionAPI;